import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, LOGO_URL } from "../lib/api";
import { Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  React.useEffect(() => { document.title = "Forgot Password – Cheap4Teach"; }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="forgot-password-page">
      <div className="c4t-card">
        <img src={LOGO_URL} alt="Cheap4Teach" className="mx-auto h-20 logo-blend" />
        <h1 className="text-3xl font-['Fredoka'] font-bold mt-4 text-center">Forgot your password?</h1>
        <p className="c4t-desc mt-2 text-center">No worries! Enter your email and we'll send you a reset link.</p>

        {sent ? (
          <div className="mt-6 c4t-card !bg-[#E6FFF7] !shadow-[4px_4px_0_#00E0AA]" data-testid="forgot-success">
            <p className="font-semibold">If that email is registered, a reset link is on its way 💌</p>
            <p className="text-sm c4t-desc mt-2">It expires in 1 hour. Check spam too just in case.</p>
            <Link to="/login" className="c4t-btn c4t-btn-pink w-full !mt-5 !no-underline">
              <ArrowLeft className="w-5 h-5" /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-semibold flex items-center gap-1.5"><Mail className="w-4 h-4" /> Email</label>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                className="c4t-input mt-1" placeholder="teacher@school.com" data-testid="forgot-email-input" />
            </div>
            <button type="submit" disabled={busy} className="c4t-btn c4t-btn-pink w-full" data-testid="forgot-submit-btn">
              {busy ? "Sending..." : "Send reset link"}
            </button>
            <Link to="/login" className="block text-center text-sm text-[#118AB2] hover:text-[#FF477E] font-semibold">
              ← Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
